// TODO: it can be written better
const placeholder = 'dd.mm.yyyy';
const mask = '__.__.____';
const separator = /\./g;
// Array of separators with index position at mask
const separatorIndexArray = Array.from(mask.matchAll(separator));
const cleanMask = mask.replace(separator, '');

/**
 * @argument {HTMLInputElement} element
 * @returns {void}
 */

function DateMask(element) {
    element.placeholder = placeholder;

    for (const type of ['input', 'change']) {
        element.addEventListener(type, onInput);
    }
}

/**
 * @param {EventTarget} event
 * @return {void}
 */

function onInput(event) {
    /** @type {HTMLInputElement} */
    const input = event.currentTarget;
    // Remember cursor position
    let cursorPos = input.selectionStart;

    const tokensIterable = (input.value).matchAll(/[0-9_]/g);
    const tokensArray = Array.from(tokensIterable);
    const tokensString = tokensArray.join('');
    // Object of tokens (index, value) with applied mask
    const tokens = Object.assign({}, cleanMask, tokensString);
    // Array of value from tokens
    const valueArray = Array.from(Object.values(tokens)).slice(0, 8);

    // Insert separators
    separatorIndexArray.forEach(({index}) => {
        valueArray.splice(index, 0, '.');

        // Increase cursor position if it equals separator index
        if (cursorPos === index) cursorPos++;
    });

    input.value = valueArray.join('');

    // Set cursor position
    input.selectionStart = cursorPos;
    input.selectionEnd = cursorPos;
}

document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('.date-mask');
    elements.forEach(DateMask);
});

export default DateMask;
